/**
 * Axios 请求工具
 * 统一处理请求头、token、错误拦截、卡密过期强退
 */

import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

const request = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器 - 自动附加 token
request.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('fdpush_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器 - 统一错误处理
request.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      // token 失效或未登录 → 强制跳转登录页
      if (status === 401) {
        localStorage.removeItem('fdpush_token');
        localStorage.removeItem('fdpush_user');
        window.dispatchEvent(new CustomEvent('auth:expired', { detail: { message: data?.message || '登录已过期' } }));
        window.location.href = '/login';
        return Promise.reject(new Error(data?.message || '请重新登录'));
      }
      // 卡密过期 → 提示并强制退出
      if (status === 403 && data?.expired) {
        window.dispatchEvent(new CustomEvent('card:expired', { detail: { message: data?.message } }));
        localStorage.removeItem('fdpush_token');
        localStorage.removeItem('fdpush_user');
        window.location.href = '/login?expired=1';
        return Promise.reject(new Error(data?.message));
      }
      return Promise.reject(new Error(data?.message || `请求失败 (${status})`));
    }
    return Promise.reject(new Error('网络连接失败，请检查网络'));
  }
);

export default request;
